import * as Yup from 'yup';
import * as React from 'react';
import PropTypes from 'prop-types';
import { useState, useEffect } from 'react';
import { useFormik, Form, FormikProvider } from 'formik';
import { useNavigate, useLocation } from 'react-router-dom';
// material

import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFns';
import { DesktopDatePicker } from '@mui/x-date-pickers/DesktopDatePicker';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import Moment from 'moment';
import { DatePicker, TimePicker } from '@mui/x-date-pickers';
import { format } from "date-fns";
import ArrowBackIosNewIcon from '@mui/icons-material/ArrowBackIosNew';
import { AccordionDetails, Select, TextareaAutosize, Autocomplete, Stack, Grid, Divider, TextField, FormControl, FormGroup, InputLabel, FormControlLabel, Checkbox, Modal, IconButton, Typography, Tooltip, MenuItem, Button, Box, Menu, Tabs, Tab, FormHelperText, FormLabel, Card, ListItemText, ListItemIcon, Chip } from '@mui/material';
import { DataGrid, GridToolbar, GridPagination } from '@mui/x-data-grid';
import { Icon } from '@iconify/react';
import { styled } from '@mui/material/styles';
import { useSnackbar } from 'notistack';
import EditIcon from '@mui/icons-material/Edit';
import ModeEditOutlineOutlinedIcon from '@mui/icons-material/ModeEditOutlineOutlined';
import ListIcon from '@mui/icons-material/List';
import ReorderOutlinedIcon from '@mui/icons-material/ReorderOutlined';
import CloseIcon from '@mui/icons-material/Close';
import ArrowForwardIosSharpIcon from '@mui/icons-material/ArrowForwardIosSharp';
import MuiAccordion from '@mui/material/Accordion';
import MuiAccordionSummary from '@mui/material/AccordionSummary';
import PersonAddAlt1OutlinedIcon from '@mui/icons-material/PersonAddAlt1Outlined';
import ManageSearchOutlinedIcon from '@mui/icons-material/ManageSearchOutlined';
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import HistoryToggleOffOutlinedIcon from '@mui/icons-material/HistoryToggleOffOutlined';
import MoreVertIcon from "@mui/icons-material/MoreVert";
import BorderColorOutlinedIcon from '@mui/icons-material/BorderColorOutlined';

import URLS from '../../../services/urls.service';
import AppCache from '../../../services/AppCache';
import { handleError } from '../../Common/Utils';
import ModalPopUp from '../../Common/ModalPopUp';
// import IssueAllocationServicePage from '../../SidebarMenuComponents/ServiceComponent/IssueAllocationServicePage'
import TextAreaWithToolbar from '../../Common/TextAreaWithToolbar';
import ApplyForLeave from '../LeaveComponent/ApplyForLeave';

// -----------------------------------------------------------------------------------------------------
const viewStyle = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '30%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    overflow: 'auto',   // 👈 you had auto, now hidden if you want
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'column',
};
const AccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#fbe9e7', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));
const TextAccordionSummary = styled((props) => (
    <MuiAccordionSummary
        expandIcon={<ArrowForwardIosSharpIcon sx={{ fontSize: '0.9rem' }} />}
        {...props}
    />
))(({ theme }) => ({
    backgroundColor: '#FFF', // Set the background color to #fbe9e7
    flexDirection: 'row-reverse',
    '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
        transform: 'rotate(90deg)',
    },
    '& .MuiAccordionSummary-content': {
        marginLeft: theme.spacing(1),
    },
}));

function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`simple-tabpanel-${index}`}
            aria-labelledby={`simple-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 1 }}>
                    <Typography>{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.number.isRequired,
    value: PropTypes.number.isRequired,
};

function a11yProps(index) {
    return {
        id: `simple-tab-${index}`,
        'aria-controls': `simple-tabpanel-${index}`,
    };
}

export default function LeaveBalanceReport({ monthYear, handleMonthYear, executive, handleExecutive, selectedExecutive, handleAttendanceReportFilter, handleMyTeamReset, attendanceReportData, attendanceReportColumn, formattedAttendanceData, handleAttendanceReportReset, pageSize4, setPageSize4, leaveReportExecutive, handleLeaveReportExecutive, selectedLeaveReportExecutive, noOfMonths, handleNoOfMonths, leaveBalanceReportData, leaveBalanceReportColumn }) {

    return (
        <Box sx={{ p: 2 }}>
            <Stack direction="row" spacing={2} alignItems="center" sx={{ mb: 2 }}>
                <FormControl size="small" fullWidth sx={{ width: 180 }}>
                    <Autocomplete
                        fullWidth
                        size="small"
                        id="executive"
                        value={selectedLeaveReportExecutive.find((option) => option.Id === leaveReportExecutive) || ""}
                        onChange={(_, newValue) => handleLeaveReportExecutive(newValue)}
                        options={selectedLeaveReportExecutive}
                        getOptionLabel={(option) => option.Name || ""}
                        isOptionEqualToValue={(option, value) => option.Id === value.Id}

                        renderInput={(params) => (
                            <TextField {...params} placeholder="Select Executive" />
                        )}
                        renderOption={(props, option) => (
                            <li {...props} key={option.Id}>
                                {option.Name}
                            </li>
                        )}
                    />


                </FormControl>
                <LocalizationProvider dateAdapter={AdapterDateFns}>
                    <DesktopDatePicker
                        views={['year', 'month']}
                        inputFormat="MMM/yyyy"
                        value={monthYear}
                        onChange={(newValue) => {
                            handleMonthYear(newValue);
                        }}
                        renderInput={(params) => (
                            <TextField
                                size="small"
                                {...params}
                                sx={{ width: 180 }}
                                placeholder="Month Year"
                            />
                        )}
                    />
                </LocalizationProvider>

                <FormControl size="small" fullWidth sx={{ width: 180 }}>
                    <TextField
                        fullWidth
                        size="small"
                        value={noOfMonths}
                        onChange={handleNoOfMonths}
                        type="number"
                        placeholder="Enter No.Of Months"

                    />
                </FormControl>

                <Tooltip title="Filter">
                    <Button
                        variant="contained"
                        size="small"
                        onClick={handleAttendanceReportFilter}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="material-symbols:search" width="20" height="20" sx={{ mr: '3px' }} />
                    </Button>
                </Tooltip>

                {/* Reset */}
                <Tooltip title="Reset">
                    <Button
                        variant="outlined"
                        size="small"
                        onClick={handleAttendanceReportReset}
                        sx={{ minWidth: 40, }}

                    >
                        <Icon icon="ic:twotone-restart-alt" width="20" height="20" />
                    </Button>
                </Tooltip>
            </Stack>

            {/* DataGrid for History */}
            <Box sx={{ height: '56vh', width: '100%', }}>
                <DataGrid rows={leaveBalanceReportData} columns={leaveBalanceReportColumn} density="compact"
                    components={{ Toolbar: GridToolbar, }}
                    pagination
                    paginationMode="client"
                    rowsPerPageOptions={[25, 50, 100]}
                    pageSize={pageSize4}
                    onPageSizeChange={(newPageSize) => setPageSize4(newPageSize)}
                />
            </Box>
        </Box>
    );
}